import { gql } from '@apollo/client';

export const PORTAL_CONFIRM_BILL = gql`
    mutation PortalConfirmBill($billId: ID!, $remark: String) {
        portalConfirmBill(billId: $billId, remark: $remark) {
            success
            errorMessage
        }
    }
`;

export const PORTAL_REJECT_BILL = gql`
    mutation PortalRejectBill($billId: ID!, $remark: String!) {
        portalRejectBill(billId: $billId, remark: $remark) {
            success
            errorMessage
        }
    }
`;

export const PORTAL_EXPORT_BILL = gql`
    mutation PortalExportBill($billId: ID!, $template: String!, $format: String!, $language: String) {
        portalExportBill(billId: $billId, template: $template, format: $format, language: $language) {
            success
            taskIds
            errorMessage
        }
    }
`;
